import { Tag } from "primereact/tag";

import { NO_PERMISSIONS_LABEL } from "../../roles.constants";
import styles from "./permission-tags.module.scss";
import type { PermissionTagsProps } from "./types-permission-tags";

/** Tags das permissões (Figma 4434:110756): quebram de linha, sem "+N"; sem permissões, a tag "sem permissões". */
export function PermissionTagsView({ permissions }: PermissionTagsProps) {
  return (
    <ul className={styles.list}>
      {permissions.length === 0 ? (
        <li>
          <Tag value={NO_PERMISSIONS_LABEL} severity="secondary" />
        </li>
      ) : (
        permissions.map((permission) => (
          <li key={permission.id}>
            <Tag value={permission.nome || permission.codigo} severity="secondary" />
          </li>
        ))
      )}
    </ul>
  );
}
